import * as axios from 'axios';
import { getAuthHeader } from './../utils';

export const getDashboardStats = () => {
    const url = `${process.env.REACT_APP_BASE_URL}/stats`;
    return axios.get(url, getAuthHeader()).then((response: any) => {
        return response.data;
    }).catch((err: any) => {
        throw err.response;
    });
}

export const getCountry = () => {
    const url = `${process.env.REACT_APP_BASE_URL}/master/country`;
    return axios.get(url, getAuthHeader()).then((response: any) => {
        return response.data;
    }).catch((err: any) => {
        throw err.response;
    });
}

export const getState = (id: any) => {
    const url = `${process.env.REACT_APP_BASE_URL}/master/state?id=${id}`;
    return axios.get(url, getAuthHeader()).then((response: any) => {
        return response.data;
    }).catch((err: any) => {
        throw err.response;
    });
}

export const getCity = (id: any) => {
    const url = `${process.env.REACT_APP_BASE_URL}/master/city?id=${id}`;
    return axios.get(url, getAuthHeader()).then((response: any) => {
        return response.data;
    }).catch((err: any) => {
        throw err.response;
    });
}